import { Button } from "rimble-ui";
import TransactionFeeCard from "../../../../src/components/documentation/snippets/TransactionFeeCard.js";
import React from 'react';
export default {
  Button,
  TransactionFeeCard,
  React
};